import React from "react";
import { InspectionPointStatus, fieldValidation } from "../../../../../amorg-common";
import { TextAreaField } from "../../../../../designSystem/formField/textArea/TextAreaField";
import { RadioButtonButtonList } from "../../../../../designSystem/inputs/RadioButtonButton";
import { Label } from "../../../../../designSystem/Label";
import { Flex } from "../../../../../designSystem/compositeComponents/FlexHelpers";
import { colors } from "../../../../../designSystem/colors/color";

type InspectionStatePanelProps = {
    status:InspectionPointStatus,
    comment:string,
    onChange:(status:InspectionPointStatus, comment:string) => void
}
export function InspectionStatePanel(props:InspectionStatePanelProps):JSX.Element
{
    
    const validComment = props.comment ? fieldValidation.facilityInspection.comment(props.comment) : true;

    const pendingColors = colors.inspectionState.pending;
    const passedColors = colors.inspectionState.passed;
    const failedColors = colors.inspectionState.failed;
    
    return (
        <Flex flexDirection="column" gap={16}>
            <div>
                <Label formIndent>
                    Status
                </Label>
                <div style={{maxWidth:500}}>
                    <RadioButtonButtonList
                        groupName='status'
                        options={[
                            {text:'Ikke kontrolleret', value:'pending', selectedColorProfile:pendingColors},
                            {text:'Godkendt', value:'passed', selectedColorProfile:passedColors},
                            {text:'Ikke-godkendt', value:'failed', selectedColorProfile:failedColors}
                        ]}
                        selectedValue={props.status}
                        onChange={(value) => props.onChange(value as InspectionPointStatus, props.comment)}
                    />
                </div>
            </div>

            <TextAreaField 
                label='Bemærkning   '
                value={props.comment}
                onChange={(value) => props.onChange(props.status, value)}
                errorMessage={validComment ? '' : `Ugyldig tekst. Må maks indeholde 1000 tegn (${props.comment.length}) `}
                minRows={3}
            />
        </Flex>
    );
}